import useAuthorisedEntities from './useAuthorisedEntities';
import useLpAccessRights from './useLpAccessRights';

export function useTermAccessRights(termKey: string) {
  const authorizedEntities = useAuthorisedEntities();
  const { hasAccessRights, hasAdminRights } = useLpAccessRights();

  if (!termKey) return [];
  if (hasAccessRights || hasAdminRights)
    return authorizedEntities?.[termKey] ?? [];

  return [];
}

export default useTermAccessRights;
